import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hybridAnalysis = defineConnector({
  identifier: "hybridAnalysis",
  name: "Hybrid Analysis",
  tagLine: "Malware analysis sandbox",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://www\\.hybrid-analysis\\.com/api/.*",
  auth: (app) =>
    headerAuth([
      { name: "api-key", value: app.secret.apiKey },
      { name: "User-Agent", value: "Falcon" },
    ]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Hybrid Analysis](https://www.hybrid-analysis.com/) and create an account. Navigate to your profile page and click on the API Key tab to generate a new API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Hybrid Analysis API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.hybrid-analysis.com/api/v2/system/version",
  },
});
